import * as React from 'react';
import { RowComponentProps } from 'ui/common/types';
import { MeatballMenu, Permission, PromptConfirmationModal } from 'ui';
import { ButtonPrimary } from 'ui';
import { isValidUrl } from 'app/infrastructure/validation/url';
import styles from './attach-link-tile.scss';
import { OnClickOutside } from 'ui/common/on-click-outside';
import { keyCodeTypes } from 'ui/common/key-code-types';
import { HotKeys } from 'react-hotkeys';
import { ReactNode } from 'react';

/**
 * @interface AttachLinkTileProps
 * Properties for AttachLinkTile component.
 */
export interface AttachLinkTileProps extends RowComponentProps {
  /**
   * The text for title in the confimation modal
   */
  textTitle?: string;
  /**
   * The text for description in the confimation modal
   */
  textConfirmDelete?: string;
  /**
   * The label text for the cancel button in the confimation modal
   */
  textCancel?: string;
  /**
   * The label text for the delete button in the confimation modal
   */
  textDelete?: string;
  /**
   * The label text for the edit button in the context menu
   */
  textEditItem?: string; 
  /**
   * The label text for the done button when editing a link
   */
  textDone?: string;

  onSelectDocumentItem?: (path?: any) => void;

  /**
   * @internal
   */
  children?: ReactNode;
  linkUrl?: any;
}

export interface AttachLinkTileState {
  isEditing: boolean; 
}

/**
 * Creates AttachLinkTile component. Represents each block of listed attached links.
 *
 */
export class AttachLinkTile extends React.Component<AttachLinkTileProps, AttachLinkTileState>  {  
  private keyMap: any;
  private handlers: any;
  constructor(props: AttachLinkTileProps) {
    super(props);

    this.state = {
      isEditing: false
    };
    this.keyMap = {
      onEnter: [keyCodeTypes.Enter]
    };
    
    this.handlers = {
      onEnter: () => this.doneEditing()
    };
  }

  private handleDeleteItem = () => {
    if (this.props.onDeleteDocumentItem) {
      this.props.onDeleteDocumentItem();
    }
  };

  private onEdit = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isEditing: true } as AttachLinkTileState);
  };

  private doneEditing = () => {     
    this.setState({
      isEditing: false
    });
  };

  public render() {

    const deleteConfirmationModal =
      <PromptConfirmationModal
          title={this.props.textDelete}
          description={this.props.textConfirmDelete}
          continueText={this.props.textDelete}
          cancelText={this.props.textCancel}
          onContinue={this.handleDeleteItem}>

        <button type="button" className="dropdown-item">{this.props.textDelete}</button>
      </PromptConfirmationModal>;

    const editButton =  <button type="button" className="dropdown-item" onClick={this.onEdit}>
                          {this.props.textEditItem}
                        </button>;

    const contextMenu = this.state.isEditing ? null :
      <Permission requireAny="remove" permissions={this.props.enabledChildEntityOperations}>
        <div className={styles.attachLinkMenu}>
          <MeatballMenu>
            <Permission permissions={this.props.enabledChildEntityOperations} isListElement={true}>
                {editButton}
            </Permission>
            <Permission requireAll="remove" permissions={this.props.enabledChildEntityOperations} isListElement={true}>
              {deleteConfirmationModal}
            </Permission>            
          </MeatballMenu>
        </div>
      </Permission>;

    const url = this.props.linkUrl && this.props.linkUrl.valueObject && this.props.linkUrl.valueObject.value;

    const editMode =  <div className={`${styles.attachLinkTile} ${styles.editMode}`}>                                        
                        <OnClickOutside onClickOutside={this.doneEditing}>
                          <HotKeys keyMap={this.keyMap} handlers={this.handlers}>
                            {this.props.details}
                            <div className="d-flex justify-content-end">
                              <ButtonPrimary onClick={this.doneEditing}>{this.props.textDone}</ButtonPrimary>
                            </div>
                          </HotKeys>
                        </OnClickOutside>
                      </div>;

    const readMode = isValidUrl(url) ?
                      <a href={url} target="_blank" rel="noopener noreferrer" className={styles.attachLinkTile}>{this.props.children}</a>
                      :
                      <div className={`${styles.attachLinkTile} ${styles.invalidUrl}`}>{this.props.children}</div>;

    return (
      <div id={this.props.componentId} className={styles.attachLinkTileWrapper}>
        {contextMenu}
        {this.state.isEditing ? editMode : readMode }
      </div>
    );
  }

}
